<template>
  <div class="addNewClass">
    <div class="content">
      <el-card class="box-card" shadow="never">
        <div slot="header">
          <span>签到规则说明</span>
        </div>
        <div>
          <div>
            <span>注意事项：</span>
            <span>中途若中断签到，则从第一天开始重新计算积分。</span>
          </div>
          <div>
            <span>特殊奖励：</span>
            <span>必须连续签到七天，否则没有特殊奖励，无补签机会。</span>
          </div>
        </div>
      </el-card>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>开启积分签到</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="22">
                <div class="">
                  <el-radio-group v-model="form.is_open">
                    <el-radio label="1">开启</el-radio>
                    <el-radio label="0">关闭</el-radio>
                  </el-radio-group>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>第一天积分奖励</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div class="grid-content bg-purple name">
                  <el-input
                    v-model="form.oneday"
                    placeholder="请输入数量"
                    size="small"
                    type="number"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>第二天积分奖励</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div class="grid-content bg-purple name">
                  <el-input
                    v-model="form.twoday"
                    placeholder="请输入数量"
                    size="small"
                    type="number"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>第三天积分奖励</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div class="grid-content bg-purple name">
                  <el-input
                    v-model="form.threeday"
                    placeholder="请输入数量"
                    size="small"
                    type="number"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>第四天积分奖励</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div class="grid-content bg-purple name">
                  <el-input
                    v-model="form.fourday"
                    placeholder="请输入数量"
                    size="small"
                    type="number"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>第五天积分奖励</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div class="grid-content bg-purple name">
                  <el-input
                    v-model="form.fiveday"
                    placeholder="请输入数量"
                    size="small"
                    type="number"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>第六天积分奖励</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div class="grid-content bg-purple name">
                  <el-input
                    v-model="form.sixday"
                    placeholder="请输入数量"
                    size="small"
                    type="number"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>第七天积分奖励</span>
            <span style="color:red">*</span>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <el-row style="margin-top:0">
              <el-col :span="14">
                <div class="grid-content bg-purple name">
                  <el-input
                    v-model="form.sevenday"
                    placeholder="请输入数量"
                    size="small"
                    type="number"
                  ></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="3">
          <div class="grid-content bg-purple name">
            <span>签到规则 </span>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="grid-content bg-purple">
            <EditorBar v-model="form.rule"></EditorBar>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20" justify="end" type="flex" style="margin-bottom:40px">
        <el-col :span="4">
          <el-button type="primary" @click="submit">
            <span>提交</span>
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import EditorBar from "@Components/public/wangEnduit";
import { mapGetters, mapActions } from "vuex";
import { detailSetRules, setRules } from "@/api/sign";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  components: {
    EditorBar
  },
  data() {
    return {
      jude: 0,
      form: {
        is_open: "1",
        oneday: "",
        twoday: "",
        threeday: "",
        fourday: "",
        fiveday: "",
        sixday: "",
        sevenday: "",
        rule: ""
      }
    };
  },
  mounted() {
    this.detailSetRules();
  },
  methods: {
    submit() {
      let data = this.form;
      data.app_id = this.app_id;
      data.token = this.token;

      console.log("提交数据", data);
      // return false;
      setRules(data).then(res => {
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        } else {
          this.$message({
            message: res.msg,
            type: "success"
          });
        }
      });
    },
    // 商品详情
    detailSetRules() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      detailSetRules(data).then(res => {
        if (res.code == 200) {
          this.form = res.data;
          this.form.is_open = String(this.form.is_open);
          console.log("form", this.form);
        }
        console.log("规则详情", res);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #8c939d !important;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.addNewClass {
  height: 100%;
  overflow-y: auto;

  .content {
    padding: 40px 100px 0 52px;
    .operation {
      height: 50px;
    }
    .el-row {
      margin-top: 15px;
    }
    .grid-content {
      line-height: 36px;
      min-height: 36px;
      .label {
        // width: 70px;
        line-height: 20px;
        // height: 20px;
        padding: 5px 15px;
        border-radius: 20px;
        background: rgba(64, 158, 255, 0.1);
        text-align: center;
        margin-right: 10px;
        position: relative;
        .close {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: #ff00004f;
          line-height: 15px;
          position: absolute;
          right: 0;
          top: -5px;
        }
      }
    }
    .labelsort {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .name {
      text-align: right;
    }
    .rgt {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .img {
    width: 80px;
    height: 80px;
    background: #ff00004f;
  }
}
</style>

<style lang="scss">
.addNewClass {
  .editor {
    width: 100%;
    .text {
      min-height: 220px;
    }
  }
}
</style>
